/* eslint-disable */
import React, { useEffect, useRef, useState } from 'react';
import { Ico } from './ShellIcons';
import fb from './filterBar.module.css';
import Navigator from './Navigator';
import { readRecents, pushRecent, readHome, toggleHome, HOME_PORTALS } from './navModel';
import { decorate, defaultSectionKey } from './navCatalog';
import { PORTAL_META, ORDERS_WORLDS } from './portalMeta';

// ============================================================
// Identity — the left edge of the filter bar: portal tile + name, the Orders
// world switcher when the portal has worlds, "› Section" (a menu of the
// portal's sections) and the live count ("4,901" / "312 of 4,901" when a
// filter is on). StatusSlot — the LIVE slot, the same place in every portal.
// ============================================================

const WORLD_SHORT = { desk: 'Desk', book: 'Book', collection: 'Collection' };
const fmt = (n) => (n == null ? '' : Number(n).toLocaleString('en-US'));

export function Identity({ portal, worlds, world, onWorld, sections = [], section, onSection, count, open, onToggle, onClose, worldCounts, onPickIn }) {
  const pillRef = useRef(null);
  const canHome = HOME_PORTALS.includes(portal.key);
  // read on every render: the bar's Identity is shared by several portals, so a value kept in state would go stale on a portal switch
  const [, bump] = useState(0);
  const home = canHome ? readHome(portal.key) : null;
  const cur = sections.find((s) => s.key === section) || sections[0];
  const curKey = cur && cur.key;
  useEffect(() => { if (curKey) pushRecent(portal.key, world, curKey); }, [portal.key, world, curKey]);
  const rows = sections.map((s) => decorate(portal.key, world, s));
  const columns = portal.key === 'orders' ? ORDERS_WORLDS.map((w) => ({ key: w.key, label: w.label, icon: w.icon, rows: w.sections.map((s) => decorate('orders', w.key, { key: s.key, label: s.label, d: s.d, count: worldCounts && worldCounts[w.key] ? worldCounts[w.key][s.key] : undefined, tone: s.key === 'exceptions' ? 'red' : undefined })) })) : null;
  const homeKey = canHome ? (home || defaultSectionKey(portal.key)) : null;
  const homeRow = homeKey && rows.find((r) => r.key === homeKey);
  const redTotal = sections.reduce((n, s) => n + (s.tone === 'red' && s.count ? s.count : 0), 0);
  return (
    <div className={fb.idn}>
      {(cur || (worlds && worlds.length > 0)) && <>
        {/* one pill: portal tile › name › section ⌄ (+ the red count) — David's v8. The menu is anchored to its own
            button (11.10: with the Orders worlds in front, a menu positioned against the whole identity opened away) */}
        <span className={fb.idSecWrap}>
          <button ref={pillRef} type="button" className={`${fb.idSec} ${open ? fb.open : ''} ${fb.loc}`} onClick={(e) => { e.stopPropagation(); onToggle(); }} aria-haspopup="menu" aria-expanded={open} title="Sections" data-test="shell-section-button"
            aria-label={`${portal.name}${WORLD_SHORT[world] ? ` · ${WORLD_SHORT[world]}` : ''}${cur ? ` · ${cur.label}` : ''} — open sections${redTotal ? ` · ${redTotal} need you` : ''}`}>
            <span className={fb.pidTile}><Ico name={portal.icon} /></span><span className={fb.idName}>{portal.name}</span>{cur || WORLD_SHORT[world] ? <span className={`${fb.idSep} ${fb.first}`}>›</span> : null}
            {worlds && worlds.length && WORLD_SHORT[world] ? <><span className={fb.idW}>{WORLD_SHORT[world] || world}</span>{cur ? <span className={fb.idSep}>·</span> : null}</> : null}
            {cur ? <span className={fb.st}>{cur.label}</span> : null}{redTotal ? <span className={fb.idBadge} title="Needs a decision">{fmt(redTotal)}</span> : null}<Ico name="chev" className={fb.chev} />
          </button>
          {open && (
            <Navigator portal={{ key: portal.key, name: portal.name, icon: portal.icon, desc: (PORTAL_META[portal.key] || {}).desc }} title={portal.name} rows={rows} columns={columns} world={world} current={cur ? cur.key : undefined} recents={readRecents(portal.key, world)} pillRef={pillRef}
              onPick={(k, w) => { if (w && w !== world && onPickIn) onPickIn(w, k); else onSection(k); }} onClose={onClose}
              home={homeKey} homeLabel={homeRow ? homeRow.label : null} onPin={canHome ? (k) => { toggleHome(portal.key, k); bump((n) => n + 1); } : undefined} />
          )}
        </span>
      </>}
      {count && (count.filtered
        ? <span className={`${fb.idCount} ${fb.filt}`}>{fmt(count.shown)} of {fmt(count.total)}</span>
        : count.total != null ? <span className={fb.idCount}>{fmt(count.total)}</span> : null)}
    </div>
  );
}

export function StatusSlot({ items = [] }) {
  const list = items.filter(Boolean);
  if (!list.length) return null;
  return (
    <div className={fb.statusSlot} title="The live slot — the same place in every portal">
      {list.map((s, i) => (s.node
        // `node` — a portal's own live pills, rendered as they are (the Orders
        // Book's verify · comments · synced pills keep their popover and their
        // precedence); they ride in the slot and collapse with it (cSt1 · cSt0).
        ? <span key={i} className={fb.statusNode} data-status-node>{s.node}</span>
        : <span key={i} className={`${fb.status} ${s.dot ? '' : fb.plain} ${s.tone === 'warn' ? fb.warn : ''}`} title={s.title}>
          {s.dot && <span className={`${fb.dot} ${fb[s.dot] || ''}`} />}
          <span className={fb.txt}>{s.text}</span>
        </span>
      ))}
    </div>
  );
}
